/*global $ moment chrono exports */

function FormattingService (formatting, formatter, comparisonFormatter, parser) {
	this.formatting = formatting;
	this.comparisonFormatter = comparisonFormatter;
	this.formatter = formatter;
	this.parser = parser;
}

FormattingService.prototype.format = function (value, item) {
	if (item.placeholder) {
		return "";
	}

	return this.formatter(value, item);
};

FormattingService.prototype.getComparisonValue = function (value, item, usageContext) {
	return this.comparisonFormatter(value, item, usageContext);
};

FormattingService.prototype.parseSearchValue = function (searchString, item) {
	if (searchString === undefined) {
		return;
	}

	return this.parser(searchString, item);
};

function FormattingServiceFactory (options) {

	var _options = $.extend(true, {
		currencySymbol: "£",
		currencyCode: "GBP",
		locale: "en_GB",
		roiRespresentation: "PERCENTAGE",
		timezone: "Europe/London",
		useCurrencyCode: false
	}, options);

	function getSearchParser (formatting) {
		if (typeof formatting.searchParser === "function")
		{
			return formatting.searchParser;
		}
		else if (formatting.multiple !== undefined)
		{
			return function (value, dataContext) {
				const dataFormatting = formatting.multiple[dataContext[formatting.multipleKey]];
				if (typeof dataFormatting === "object")
				{
					const parser = getSearchParser(dataFormatting);
					if (typeof parser === "function")
					{
						return parser(value, dataContext);
					}
				}
				return value;
			};
		}
		else if (formatting.type === "DATE_AND_TIME")
		{
			return function (value) {
				var parsedDate;
				if (value.toUpperCase() === "N/A") return null;
				
				if (_options.locale === "en_US")
				{
					parsedDate = chrono.en.parseDate(value);
				}
				else
				{
					parsedDate = chrono.en_GB.parseDate(value);
				}

				if (parsedDate !== null)
				{
					const format = formatting.format || "DD/MM/YYYY HH:mm";
					const timezone = formatting.timezone || _options.timezone;
					return moment.tz(moment(parsedDate.valueOf()).tz(timezone).format(format), format, timezone).valueOf();
				}
				else
				{
					return NaN;
				}
			};
		}
		else if (formatting.type === "DURATION")
		{
			return function (value) {
				var parsedDate;
				if (value.toUpperCase() === "N/A") return null;
				
				if (_options.locale === "en_US")
				{
					parsedDate = chrono.en.parseDate(value);
				}
				else
				{
					parsedDate = chrono.en_GB.parseDate(value);
				}

				if (parsedDate !== null)
				{
					return parsedDate.valueOf();
				}
				else
				{
					return NaN;
				}
			};
		}
		else if (formatting.type === "DATE")
		{
			return function (value) {
				var parsedDate;
				if (value.toUpperCase() === "N/A") return null;
				
				if (_options.locale === "en_US")
				{
					parsedDate = chrono.en.parseDate(value);
				}
				else
				{
					parsedDate = chrono.en_GB.parseDate(value);
				}

				if (parsedDate !== null)
				{
					return moment(parsedDate).startOf("d").valueOf();
				}
				else
				{
					return NaN;
				}
			};
		}
		else
		{
			return function (value) {
				return value;
			};
		}
	}

	function getComparisonFormatter (formatting) {
		if (typeof formatting.comparisonFormatter === "function")
		{
			return formatting.comparisonFormatter;
		}
		else if (formatting.multiple !== undefined)
		{
			return function (value, dataContext, usageContext) {
				const dataFormatting = formatting.multiple[dataContext[formatting.multipleKey]];
				if (typeof dataFormatting === "object")
				{
					const formatter = getComparisonFormatter(dataFormatting);
					if (typeof formatter === "function")
					{
						return formatter(value, dataContext, usageContext);
					}
				}
				return value;
			};
		}
		else if (formatting.type === "DATE_AND_TIME")
		{
			return function (value, dataContext) {
				if (typeof value !== "number") {
					return null;
				}

				const format = formatting.format || "DD/MM/YYYY HH:mm";
				return moment(moment(value).tz(formatting.timezone || dataContext.timezone || _options.timezone).format(format), format).valueOf();
			};
		}
		else if (formatting.type === "DATE")
		{
			return function (value, dataContext) {
				if (typeof value !== "number") {
					return null;
				}
				return moment(moment(value).tz(formatting.timezone || dataContext.timezone || _options.timezone).format("DD/MM/YYYY"), "DD/MM/YYYY").valueOf();
			};
		}
		else if (formatting.type === "DURATION")
		{
			var durationFormatter = getFormatter(formatting);
			return function (value, dataContext) {
				if (typeof value !== "number") {
					return null;
				}

				var humanizedDate = durationFormatter(value, dataContext);
				var parsedDate;
				if (_options.locale === "en_US")
				{
					parsedDate = chrono.en.parseDate(humanizedDate, formatting.from);
				}
				else
				{
					parsedDate = chrono.en_GB.parseDate(humanizedDate, formatting.from);
				}

				if (parsedDate !== null)
				{
					return parsedDate.valueOf();
				}
			};
		}
		else if (formatting.type === "PERCENTAGE" || (formatting.type === "ROI" && _options.roiRespresentation === "PERCENTAGE"))
		{
			return function (value) {
				if (typeof value !== "number") {
					return;
				}
				return value.toFixed(formatting.dp + 2) * 1;
			};
		}
		else if (formatting.type === "NUMBER" || formatting.type === "CURRENCY")
		{
			return function (value) {
				if (typeof value !== "number") {
					return;
				}
				return value.toFixed(formatting.dp) * 1;
			};
		}
		else
		{
			return function (value) {
				return value;
			};
		}
	}

	function getFormatter (formatting) {
		if (typeof formatting.formatter === "function")
		{
			return formatting.formatter;
		}
		else if (formatting.multiple !== undefined)
		{
			return function (value, dataContext) {
				const dataFormatting = formatting.multiple[dataContext[formatting.multipleKey]];
				if (typeof dataFormatting === "object")
				{
					const formatter = getFormatter(dataFormatting);
					if (typeof formatter === "function")
					{
						return formatter(value, dataContext);
					}
				}
				return value;
			};
		}
		else if (formatting.type === "BOOLEAN")
		{
			return function (value) {
				if (value) { 
					return "Yes";
				}

				return "No";
			};
		}
		else if (formatting.type === "DATE_AND_TIME")
		{
			return function (value, dataContext) {
				if (value === null) {
					return formatting.missingValue ? formatting.missingValue : "N/A";
				}

				if (typeof value !== "number") return value;
				
				var format;
				if (formatting.format !== undefined)
				{
					format = formatting.format;
				}
				else if (_options.locale === "en_US")
				{
					format = "MM/DD/YYYY HH:mm";
				}
				else
				{
					format = "DD/MM/YYYY HH:mm";
				}

				return moment(value).tz(formatting.timezone || dataContext.timezone || _options.timezone).format(format);
			};
		}
		else if (formatting.type === "DATE")
		{
			return function (value, dataContext) {
				if (dataContext.placeholder) {
					return "";
				}

				if (value === null) {
					return formatting.missingValue ? formatting.missingValue : "N/A";
				}
				if (_options.locale === "en_US") {
					return moment(value).tz(formatting.timezone || dataContext.timezone || _options.timezone).format("MM/DD/YYYY");
				}

				return moment(value).tz(formatting.timezone || dataContext.timezone || _options.timezone).format("DD/MM/YYYY");
			};
		}
		else if (formatting.type === "DURATION")
		{
			return function (value, dataContext) {
				if (dataContext.placeholder) {
					return "";
				}

				if (value === null) {
					return formatting.missingValue ? formatting.missingValue : "N/A";
				}

				var duration = moment.duration(moment(value).diff(moment(formatting.from)));
				var formattedDuration = "";
				if (formatting.as === undefined)
				{
					formattedDuration = duration.humanize(true);
					formattedDuration = formattedDuration.charAt(0).toUpperCase() + formattedDuration.slice(1);
				}
				else
				{
					var durationAs = duration.as(formatting.as).toFixed(0)*1;
					var isNegative = false;
					if (durationAs < 0)
					{
						durationAs *= -1;
						isNegative = true;
					}
					else
					{
						formattedDuration += "In ";
					}

					formattedDuration += $.formatNumber(durationAs, {
						locale: _options.locale,
						format: "##0",
					});

					if (durationAs === 1)
					{
						formattedDuration += " ";
						switch (formatting.as)
						{
						case "y":
							formattedDuration += "Year";
							break;
						case "M":
							formattedDuration += "Month";
							break;
						case "w":
							formattedDuration += "Week";
							break;
						case "d":
							formattedDuration += "Day";
							break;
						case "h":
							formattedDuration += "Hour";
							break;
						case "m":
							formattedDuration += "Minute";
							break;
						case "s":
							formattedDuration += "Second";
							break;
						case "ms":
							formattedDuration += "Millisecond";
							break;
						}
					}
					else
					{
						formattedDuration += " ";
						switch (formatting.as)
						{
						case "y":
							formattedDuration += "Years";
							break;
						case "M":
							formattedDuration += "Months";
							break;
						case "w":
							formattedDuration += "Weeks";
							break;
						case "d":
							formattedDuration += "Days";
							break;
						case "h":
							formattedDuration += "Hours";
							break;
						case "m":
							formattedDuration += "Minutes";
							break;
						case "s":
							formattedDuration += "Seconds";
							break;
						case "ms":
							formattedDuration += "Milliseconds";
							break;
						}
					}
					
					if (isNegative)
					{
						formattedDuration += " Ago";
					}
				}
				return formattedDuration;
			};
		}
		else if (formatting.type === "NUMBER" || 
				formatting.type === "CURRENCY" || 
				formatting.type === "PERCENTAGE" || 
				formatting.type === "ROI")
		{
			var config = {
				locale: _options.locale
			};

			if (formatting.thousandSeparator === undefined || formatting.thousandSeparator)
			{
				config.format = "#,##0";
			}
			else
			{
				config.format = "##0";
			}

			if (formatting.dp > 0)
			{
				config.format += ".";
				for (var i = 0; i < formatting.dp; i++) {
					config.format += "0";
				}
			}

			switch (formatting.type)
			{
			case "CURRENCY":
				if (!_options.useCurrencyCode)
				{
					config.currencySymbol = _options.currencySymbol;
				}
				break;
			case "PERCENTAGE":
				config.format = config.format + "%";
				break;
			case "ROI":
				if (_options.roiRespresentation === "CURRENCY")
				{
					config.currencySymbol = _options.currencySymbol;
				}
				else
				{
					config.format = config.format + "%";
				}
				break;
			}
		
			return function (value, dataContext) {

				if (value === undefined) return "-";
						
				if (value === null) { 
					return formatting.missingValue ? formatting.missingValue : "N/A";
				}

				if (typeof value !== "number") return value;

				if (value === Number.POSITIVE_INFINITY)
				{
					return formatting.infinityValue ? formatting.infinityValue : "∞";
				}
				else if (value === Number.NEGATIVE_INFINITY)
				{
					return "-" + (formatting.infinityValue ? formatting.infinityValue : "∞");
				}
				
				var prefix = "";
				if (formatting.displayPlus && value >= 0) {
					prefix = "+";
				}

				var suffix = "";

				if (formatting.type === "CURRENCY" && _options.useCurrencyCode)
				{
					if (dataContext.currencyCode !== undefined)
					{
						suffix += " " + dataContext.currencyCode;
					}
					else
					{
						suffix += " " + _options.currencyCode;
					}
				}

				return prefix + $.formatNumber(value, config) + suffix;
			};
		}
		else
		{
			return function (value) {
				return value;
			};
		}
	}

	function getFormattingService (formatting) {
		return new FormattingService(
			formatting,
			getFormatter(formatting),
			getComparisonFormatter(formatting),
			getSearchParser(formatting)
		);
	}

	return {
		getFormattingService: getFormattingService,
	};
}

if (typeof exports !== "undefined")
{
	exports.FormattingServiceFactory = FormattingServiceFactory;
	exports.FormattingService = FormattingService;
} 